import { createMuiTheme } from "@material-ui/core/styles";
import { ruRU } from "@material-ui/core/locale";

export const theme = createMuiTheme(
  {
    typography: {
      fontFamily: "Roboto",
      fontSize: 14,
    },
    palette: {
      primary: {
        light: "#6573e4",
        main: "#2848b1",
        dark: "#002280",
        contrastText: "#fff",
      },
      secondary: {
        light: "#efefef",
        main: "#bdbdbd",
        dark: "#8d8d8d",
        contrastText: "#444",
      },
    },
  },
  ruRU
);

//
